import React, { useState } from "react"
import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap"
import { FormattedMessage, FormattedNumber, defineMessages, injectIntl } from "react-intl"
import { ConnectedProps, connect } from "react-redux"
import IntlProps from "../../../../state/helpers/IntlProps"
import PriceLevel from "../../../../state/price-level/PriceLevel"
import { getPriceLevels } from "../../../../state/price-level/PriceLevelSelector"
import ProductPrice, { ProductPriceDto } from "../../../../state/product-price/ProductPrice"
import { ProductPriceWithName } from "../../../../state/product-price/types"
import { createNewProductPriceWithName } from "../../../../utils/product-price/utils"
import MoneyInputForm from "../../../form/moneyinput.component"
import { UnitPriceProps } from "../../../types"

const messages = defineMessages({
    placeholder: {
        id: "common.pricing.add_item_modal.price_level_select.placeholder",
        defaultMessage: "Select a Price Level"
    }
})

const UnitPriceInput = ({
    unitPrice,
    onChange,
    currency,
    disabled,
    productPrices,
    priceLevels,
    selectedPriceLevelId,
    isBundle,
    intl
}: Props & IntlProps) => {
    const getProductPrices = () => {
        if (productPrices && productPrices.length > 0) {
            return productPrices.map((p: ProductPriceDto) => new ProductPrice(p))
        }
        return []
    }

    const getProductPricesWithName = () => {
        const ppWithName = new Array<ProductPriceWithName>()
        getProductPrices().forEach(pp => {
            const priceLevel = priceLevels?.find(pl => pl.getId() === pp.getPriceLevelId()) as PriceLevel
            if (priceLevel) {
                ppWithName.push(createNewProductPriceWithName(pp))
            }
        })
        return ppWithName
    }

    const [unitPriceVal, setUnitPrice] = useState(unitPrice)
    const [selectedLevelId, setSelectedLevelId] = useState(selectedPriceLevelId)

    const getSelectedPriceLevel = () => {
        return getProductPricesWithName().find(pl => pl.priceLevelId === selectedLevelId && !pl.isArchived)
    }

    const handleInputChange = (val: string) => {
        setUnitPrice(val)
        setSelectedLevelId("")
        onChange(val, "")
    }

    const handlePriceLevelSelect = (eventKey: string) => {
        const selectedPriceLevel = getProductPricesWithName().find(pl => pl.priceLevelId === eventKey)
        if (selectedPriceLevel) {
            setSelectedLevelId(selectedPriceLevel.priceLevelId)
            if (selectedPriceLevel.price) {
                onChange(selectedPriceLevel.price, selectedPriceLevel.priceLevelId)
                setUnitPrice(selectedPriceLevel.price)
            }
        }
    }

    return (
        <div className="form-group form-row">
            <label className="col-5 col-form-label text-md-right">
                <FormattedMessage id="quote.add_item_modal.configure.unit_price_label" defaultMessage="Unit price" />
            </label>
            <div className="col-7 d-flex flex-wrap flex-column">
                <MoneyInputForm
                    currency={currency}
                    name="unitPrice"
                    value={unitPriceVal}
                    onChange={val => handleInputChange(val)}
                    id={"unitPrice"}
                    disabled={disabled}
                />
                {getProductPricesWithName() && getProductPricesWithName().length > 0 && !isBundle && (
                    <DropdownButton
                        as={ButtonGroup}
                        key={"up"}
                        id={"dropdown-button-price-level"}
                        drop="down"
                        variant="secondary"
                        title={getSelectedPriceLevel()?.name || intl.formatMessage(messages.placeholder)}
                        onSelect={eventKey => handlePriceLevelSelect(eventKey as string)}
                        className="w-auto flex-fill"
                    >
                        {
                            getProductPricesWithName()
                                .filter(level => !level.isArchived)
                                .map(level => (
                                    <Dropdown.Item eventKey={level.priceLevelId} key={level.priceLevelId}>
                                        {level.name} -&nbsp;
                                        <FormattedNumber style="currency" currency={currency} value={level.price} />
                                    </Dropdown.Item>
                                ))
                        }
                    </DropdownButton>
                )}
            </div>
        </div>
    )
}

const mapState = (state, props: UnitPriceProps) => {
    return {
        ...props,
        priceLevels: getPriceLevels(state)
    }
}
const mapDispatch = {}
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(UnitPriceInput))



// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/components/UnitPriceInput.tsx